<template>
  <div class="aboutpage2">
    <div class="page2-box w-main">
      <div class="page2-box-left">
        <div class="left-title">学会荣誉</div>
        <div
          class="left-text"
          v-for="(item, index) in contentList"
          :key="index"
        >
          <span class="left-icon"></span>
          {{ item.content }}
        </div>
      </div>
      <div class="page2-box-right">
        <div class="imgList" v-for="(item, index) in picList" :key="index">
          <el-image :src="item.content" fit="fill"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSocietyHonors } from "@/api/api.js";

export default {
  data() {
    return {
      contentList: [],
      picList: []
    };
  },
  mounted() {
    this.getSocietyHonors();
  },
  methods: {
    getSocietyHonors() {
      getSocietyHonors().then(res => {
        if (res.code === 0) {
          this.contentList = res.data.contentList;
          this.picList = res.data.picList;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.aboutpage2 {
  .page2-box {
    display: flex;
    justify-content: space-between;
    &-left {
      margin-right: 20px;
      width: calc(100% - 260px);
      .left-title {
        margin-bottom: 40px;
        font-size: 40px;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 40px;
      }
      .left-text {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
        padding-left: 20px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 30px;
        box-sizing: border-box;
        .left-icon {
          position: absolute;
          left: 0;
          top: 10px;
          display: inline-block;
          width: 10px;
          height: 10px;
          background: rgba(22, 81, 148, 1);
          transform: rotate(45deg);
        }
      }
    }
    &-right {
      // display: flex;
      // flex-flow: wrap;
      // justify-content: space-between;
      width: 260px;
      .imgList {
        margin-bottom: 20px;
        width: 260px;
        height: 169px;
        overflow: hidden;
        // margin-right: 28px;
      }
    }
  }
}
</style>
